module.exports = __webpack_public_path__ + "static/img/home_adv_photo4@2x.4293010.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homepage/ourAdvantage/home_adv_photo4@2x.png
// module id = z7w8
// module chunks = 0